module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price-info"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.3333 6.66667C13.3333 10.3487 10.3487 13.3333 6.66667 13.3333C2.98467 13.3333 0 10.3487 0 6.66667C0 2.98467 2.98467 0 6.66667 0C10.3487 0 13.3333 2.98467 13.3333 6.66667ZM6 4C6 4.17681 6.07024 4.34638 6.19526 4.4714C6.32029 4.59643 6.48986 4.66667 6.66667 4.66667H6.672C6.84881 4.66667 7.01838 4.59643 7.1434 4.4714C7.26843 4.34638 7.33867 4.17681 7.33867 4C7.33867 3.82319 7.26843 3.65362 7.1434 3.5286C7.01838 3.40357 6.84881 3.33333 6.672 3.33333H6.66667C6.48986 3.33333 6.32029 3.40357 6.19526 3.5286C6.07024 3.65362 6 3.82319 6 4ZM6.66667 10C6.84348 10 7.01305 9.92976 7.13807 9.80474C7.26309 9.67971 7.33333 9.51014 7.33333 9.33333V6C7.33333 5.82319 7.26309 5.65362 7.13807 5.5286C7.01305 5.40357 6.84348 5.33333 6.66667 5.33333C6.48986 5.33333 6.32029 5.40357 6.19526 5.5286C6.07024 5.65362 6 5.82319 6 6V9.33333C6 9.51014 6.07024 9.67971 6.19526 9.80474C6.32029 9.92976 6.48986 10 6.66667 10Z",
      "fill": "#3172DF"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Includes all mandatory dealer fees and dealer-installed addons. Excludes tax, title, license, and\n        registration fees.\n        "), _c('button', {
    staticClass: "open-disclaimer-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.modal.open()
      }
    }
  }, [_vm._v("View Full\n            Disclaimer")])]), _vm._v(" "), _c('f7-popup', {
    ref: "modal"
  }, [_c('price-disclaimer', {
    on: {
      "close": function($event) {
        return _vm.$refs.modal.close()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5398138a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5398138a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/inventory/price-info.vue
// module id = 827
// module chunks = 0